var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Box } from '@chakra-ui/react';
import { observer } from 'mobx-react';
import React from 'react';
import { StoreContext } from '../uistore/Rootstore';
let NewDatasheetDialog = class NewDatasheetDialog extends React.Component {
    constructor() {
        super(...arguments);
        this.boxref = null;
        this.adjustx = 0;
        this.adjusty = 0;
        this.upcb = () => {
            const rstore = this.context;
            rstore.addMiscStore.setDragging(false);
        };
        this.mousemove = (e) => {
            const rstore = this.context;
            if (rstore.addMiscStore.dragging) {
                // lets move this dialog 
                rstore.addMiscStore.setTop(e.clientY - this.adjusty);
                rstore.addMiscStore.setLeft(e.clientX - this.adjustx);
            }
        };
    }
    componentDidMount() {
        window.addEventListener("mouseup", this.upcb);
        window.addEventListener("mousemove", this.mousemove);
    }
    componentWillUnmount() {
        window.removeEventListener("mouseup", this.upcb);
        window.removeEventListener("mousemove", this.mousemove);
    }
    render() {
        const rstore = this.context;
        if (!rstore.addMiscStore.show) {
            return React.createElement(React.Fragment, null);
        }
        return React.createElement(Box, { pos: 'relative', "object-chooser": 'newdatasheet', ref: (ref) => this.boxref = ref, bg: 'white', borderRadius: '4px', className: 'floating-dialog', zIndex: 5000, cursor: rstore.addMiscStore.dragging ? 'grabbing' : '', onMouseDown: (e) => {
                var _a, _b;
                const tgt = e.target;
                if (tgt.getAttribute("newdatasheet")) {
                    rstore.addMiscStore.setDragging(true);
                    if (this.boxref) {
                        this.adjustx = e.clientX - ((_a = this.boxref) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left);
                        this.adjusty = e.clientY - ((_b = this.boxref) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().top);
                    }
                }
            }, position: 'fixed', left: rstore.addMiscStore.left + "px", top: rstore.addMiscStore.top + "px", width: rstore.addMiscStore.width + "px", height: (rstore.addMiscStore.height) + "px" });
    }
};
NewDatasheetDialog.contextType = StoreContext;
NewDatasheetDialog = __decorate([
    observer
], NewDatasheetDialog);
export { NewDatasheetDialog };
